import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Menu from "./Menu";
import Footer from "./Footer";

const CoachLayout = () => {
  return (
    <div className="wrapper">
      <Header />
      <Menu />

      <div className="content-wrapper">
        <section className="content pt-3">
          <Suspense
            fallback={
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "60vh" }}
              >
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default CoachLayout;
